/*
 *  version-watch.js - boots Kanlibs/KAN_VersionWatch.js on every km PAGE.
 *
 *  Not imported by any page: webpack.config.cjs puts it FIRST in every page entry
 *  (the Watched() helper), so a page added later cannot forget it, and
 *  tests/version-watch-wiring.test.mjs fails any HtmlWebpackPlugin page whose entry
 *  does not start with it. km hosts no live game view, so km has no exceptions.
 *
 *  The build identity comes from DefinePlugin - the same webpack run that writes
 *  dist/.build-info.json, which /api/version answers from.
 *
 *  Copyright 2026 Kanoogi Inc. | All Rights Reserved.
 */

"use strict";

import { StartVersionWatch } from '../../Kanlibs/KAN_VersionWatch.js';

StartVersionWatch(
	{
	service:'km',
	endpoint:'/api/version',
	build:{sha:__KM_BUILD_SHA__, builtAt:__KM_BUILD_TIME__},
	});
